export interface ILoadingWords {
	first: string;
	second: string;
}

export const LOADING_KEYWORDS_LIST: string[] = [
	"loadingPage.keyword_1",
	"loadingPage.keyword_2",
	"loadingPage.keyword_3",
	"loadingPage.keyword_4",
	"loadingPage.keyword_5",
];

export const LOADING_WORDINGS_LIST: ILoadingWords[] = [
	{
		first: "loadingPage.loadingText1_1",
		second: "loadingPage.loadingText1_2",
	},
	{
		first: "loadingPage.loadingText2_1",
		second: "loadingPage.loadingText2_2",
	},
	{
		first: "loadingPage.loadingText1_1",
		second: "loadingPage.loadingText1_2",
	},
	{
		first: "loadingPage.loadingText2_1",
		second: "loadingPage.loadingText2_2",
	},
	{
		first: "loadingPage.loadingText3_1",
		second: "loadingPage.loadingText3_2",
	},
];
